import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IReportList } from '../models';

export const reportApi = createApi({
  reducerPath: 'reportApi',
  baseQuery,
  endpoints: (builder) => ({
    getReportList: builder.query<IReportList[], any>({
      query: (page) => `/reports/reports_notifications/1/?page=${page}`,
    }),
    getReportListCount: builder.query<any, any>({
      query: () => `/reports/count_reports_notification/1/`,
      transformResponse: (_, meta) => {
        return meta?.response?.headers.get('X-Notification-Count') || 0;
      },
    }),
    readReport: builder.query<void, number>({
      query: (id) => ({
        url: `/reports/report_notification/1/${id}/`,
        method: 'PATCH',
        body: JSON.stringify({
          is_read: true,
        }),
      }),
    }),
  }),
});

export const {
  useGetReportListQuery,
  useLazyGetReportListQuery,
  useGetReportListCountQuery,
  useLazyGetReportListCountQuery,
  useLazyReadReportQuery,
} = reportApi;
